<template>
  <div class="tiktok-options">
    <el-form :model="settings" label-position="top" size="small">
      <el-form-item>
        <template v-if="loading">
          <el-skeleton :rows="1" animated />
        </template>
        <template v-else>
          <el-avatar :src="settings.creator_avatar_url" size="small" />
          <span class="creator-label">Posting as: </span>
          <strong>{{ settings.creator_nickname || settings.creator_username }}</strong>
        </template>
      </el-form-item>

      <el-divider />

      <el-form-item label="Who can view this video">
        <template v-if="loading">
          <el-skeleton :rows="1" animated />
        </template>
        <template v-else>
          <el-select
            v-model="settings.privacy_level"
            placeholder="Select visibility..."
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="option in privacyOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </template>
      </el-form-item>

      <el-form-item label="Allow users to">
        <template v-if="loading">
          <el-skeleton :rows="1" animated />
        </template>
        <template v-else>
          <el-switch v-model="settings.allow_comment" active-text="Comment" />
          <el-switch v-model="settings.allow_duet" active-text="Duet" />
          <el-switch v-model="settings.allow_stitch" active-text="Stitch" />
        </template>
      </el-form-item>

      <el-alert
        v-if="!loading && settings.max_video_post_duration_sec"
        type="info"
        :closable="false"
        show-icon
        class="max-duration-alert"
      >
        Max video post duration: {{ formatDuration(settings.max_video_post_duration_sec) }}
      </el-alert>
      <p class="tiktok-terms">
        By posting, you agree to TikTok's
        <a
          href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
          target="_blank"
          >Music Usage Confirmation</a
        >.
      </p>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'TikTokOptions',
  props: {
    settings: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    privacyOptions() {
      const map = {
        PUBLIC_TO_EVERYONE: { value: 'PUBLIC_TO_EVERYONE', label: 'Public' },
        FOLLOWER_OF_CREATOR: { value: 'FOLLOWER_OF_CREATOR', label: 'Followers' },
        MUTUAL_FOLLOW_FRIENDS: { value: 'MUTUAL_FOLLOW_FRIENDS', label: 'Friends' },
        SELF_ONLY: { value: 'SELF_ONLY', label: 'Private (Only me)' },
      };
      return (this.settings.privacy_level_options || []).map(opt => map[opt]).filter(Boolean);
    },
  },
  methods: {
    formatDuration(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''}`;
      return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    },
  },
};
</script>

<style scoped>
.tiktok-options {
  border: 1px solid #e5e7eb;
  padding: 16px;
  border-radius: 2px;
}

.creator-label {
  font-size: 12px;
  color: #909399;
  margin-top: 20px;
}

.max-duration-alert {
  margin-top: 12px;
}

.tiktok-options el-skeleton {
  margin: 12px 0;
}
.tiktok-terms {
  font-size: 12px;
  color: #909399;
  margin-top: 16px;
}
.tiktok-terms a {
  color: #409eff;
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// TikTokOptions.vue?a4f49122